<template>
	<div class="mainVue">
    <router-view></router-view>
	</div>
</template>
<script>
export default {
  components: {
  }
};
</script>
<style scoped lang="less">
.mainVue{
  
}
</style>
